module.exports = __webpack_public_path__ + "static/media/th_bg_desktop.603fe50e.png";